import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Backdrop from "@material-ui/core/Backdrop";
import SpeedDial from "@material-ui/lab/SpeedDial";
import SpeedDialIcon from "@material-ui/lab/SpeedDialIcon";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction";
import FileCopyIcon from "@material-ui/icons/FileCopyOutlined";
import SaveIcon from "@material-ui/icons/Save";
import PrintIcon from "@material-ui/icons/Print";
import ShareIcon from "@material-ui/icons/Share";
import FavoriteIcon from "@material-ui/icons/Favorite";

import TouchApp from "@material-ui/icons/TouchAppOutlined";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";
import { Typography, Zoom } from "@material-ui/core";
import { Add, QueuePlayNextOutlined } from "@material-ui/icons";
import { useDispatch } from "react-redux";
import { openCommonPageModal } from "../../redux/action/utilActions";
import UseMobile from "../../hooks/useIsMobile";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      backgroundColor: "white",
    },
  },
  speedDial: {
    position: "absolute",
    bottom: theme.spacing(3),
    right: theme.spacing(3),
  },
  touchIcon: {
    fontSize: "2rem",
  },
  action: {
    backgroundColor: theme.palette.primary.main,
  },
}));

const AddPanchayatBtn = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const trigger = useScrollTrigger({
    target: window ? window : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClick = () => {
    dispatch(
      openCommonPageModal({
        title: "તમારી ગ્રામ પંચાયત ઉમેરો",
        link: "addpanchayat",
      })
    );
  };
  const actions = [
    { icon: <FileCopyIcon />, name: "Copy" },
    { icon: <SaveIcon />, name: "Save" },
    { icon: <PrintIcon />, name: "Print" },
    { icon: <ShareIcon />, name: "Share" },
    { icon: <FavoriteIcon />, name: "Like" },
  ];
  const isMobile = UseMobile();
  return (
    isMobile && (
      <Zoom in={!trigger}>
        <Button
          onClick={() => handleClick()}
          color="primary"
          startIcon={<Add />}
          variant="contained"
          className={classes.speedDial}
        >
          તમારી ગ્રામ પંચાયત ઉમેરો
        </Button>
      </Zoom>
    )
  );
};
export default AddPanchayatBtn;
